/**
 * Centralized Keycloak realm-role names referenced from frontend code.
 *
 * Until this file existed these names lived as bare string literals
 * scattered across auth-service, the user menu, route guards, and the
 * Part B component. Centralizing them removes the typo class of bug
 * (a misspelled literal silently fails every role check forever) and
 * gives reviewers a single grep target for "which roles does the
 * frontend care about?".
 *
 * Role *values* must match the Keycloak realm-role names exactly,
 * including case. `Dashboard` is intentionally capitalized to match
 * the Lesotho2 realm definition.
 */

export const ROLE_PARTB = 'partb';
export const ROLE_SUPER_MARIO = 'super_mario';
export const ROLE_SUPERINSPECTOR = 'superinspector';
export const ROLE_SYSADMIN = 'sysadmin';
export const ROLE_DASHBOARD = 'Dashboard';

/**
 * Realm roles whose holders retain access to the homepage (`/`).
 *
 * Used by:
 *   - PartBLandingGuard — skip the auto-redirect from `/` to `/part-b`.
 *   - User menu — show the Applicant link (route to `/`).
 *
 * Adding a role here is safe across all country realms: a realm that
 * does not define the role simply assigns it to nobody, so the entry
 * is inert there. Per-country realms grow this list as new roles are
 * given homepage responsibilities.
 *
 *   - `super_mario` — back-office access (Kenya, others).
 *   - `Dashboard`   — Lesotho2 homepage features for registrars.
 */
export const HOMEPAGE_ACCESS_ROLES: readonly string[] = [
  ROLE_SUPER_MARIO,
  ROLE_DASHBOARD
];
